(function () {
  const HEADER_SELECTOR = '#header-component';
  const THRESHOLD = 8;
  const REVEAL_AT_TOP_PX = 24;

  let header = null;
  let lastY = 0;
  let accum = 0;
  let raf = null;
  let current = 'none';

  function setDir(next) {
    if (next === current || !header) return;
    current = next;
    header.dataset.bysScroll = next;
  }

  function onScroll() {
    if (raf !== null) return;
    raf = requestAnimationFrame(() => {
      raf = null;
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      const delta = y - lastY;

      if (y <= REVEAL_AT_TOP_PX) {
        setDir('none');
        accum = 0;
      } else if (delta > 0) {
        accum = accum > 0 ? accum + delta : delta;
        if (accum >= THRESHOLD) setDir('down');
      } else if (delta < 0) {
        accum = accum < 0 ? accum + delta : delta;
        if (accum <= -THRESHOLD) setDir('up');
      }

      lastY = y;
    });
  }

  function init() {
    header = document.querySelector(HEADER_SELECTOR);
    if (!header) return;
    lastY = window.scrollY || 0;
    header.dataset.bysScroll = 'none';
    document.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Pause pill transitions during active viewport resize so the drawer<->menu
   layout flip doesn't fight the bar's max-width / border-radius animations. */
(function () {
  let timer = null;
  const RELEASE_MS = 200;

  function onResize() {
    document.documentElement.setAttribute('data-bys-resizing', '');
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      document.documentElement.removeAttribute('data-bys-resizing');
      timer = null;
    }, RELEASE_MS);
  }

  window.addEventListener('resize', onResize, { passive: true });
})();

/* Force a single, predictable drawer<->menu breakpoint.
   The Horizon default flips to drawer based on overflow-list's "minimum
   reached" signal, which fires at unpredictable widths (depending on label
   length). That made items mysteriously disappear into "Mer" at some
   widths. Instead we pick one width — below it always drawer, above it
   always full menu — and override the theme's decision after it runs. */
(function () {
  const HEADER_SELECTOR = '#header-component';
  const BREAKPOINT_PX = 990;
  let suppress = false;

  function apply() {
    const header = document.querySelector(HEADER_SELECTOR);
    if (!header) return;
    const desired = window.innerWidth < BREAKPOINT_PX ? 'drawer' : 'menu';
    if (header.dataset.menuStyle !== desired) {
      suppress = true;
      header.dataset.menuStyle = desired;
      requestAnimationFrame(() => (suppress = false));
    }
  }

  function init() {
    const header = document.querySelector(HEADER_SELECTOR);
    if (!header) return;
    apply();

    // Re-assert after the theme's own setHeaderMenuStyle runs (debounced 100ms on resize).
    window.addEventListener('resize', () => {
      apply();
      setTimeout(apply, 150);
    }, { passive: true });

    // Catch the theme's writes and bounce back to our value.
    new MutationObserver(() => {
      if (suppress) return;
      apply();
    }).observe(header, { attributes: true, attributeFilter: ['data-menu-style'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
